import { Component } from '@angular/core';
import { ContentComponent } from '../../components/content/content.component';
import { BreadcrumbsComponent } from '../../common/breadcrumbs/breadcrumbs.component';

@Component({
  selector: 'app-how-to-use-page',
  standalone: true,
  imports: [
    ContentComponent,
    BreadcrumbsComponent
  ],
  templateUrl: './how-to-use-page.component.html'
})
export class HowToUsePageComponent {

}
